import { api } from './client'

const userService = {
  getMe: async () => {
    return api.get('/users/me')
  },

  getUsers: async ({ q, limit = 50, offset = 0 } = {}) => {
    const params = { limit, offset }
    if (q) params.q = q
    return api.get('/users', params)
  },

  resetPassword: async (userId, password) => {
    return api.post(`/users/${userId}/reset-password`, { password })
  },

  // Per-user-per-tenant settings (server-persisted via cb-api + D1). Reads are
  // best-effort: a failure returns {} so the UI falls back to defaults.
  getSettings: async () => {
    const resp = await api.get('/users/me/settings')
    return resp?.data?.settings || {}
  },
  updateSettings: async (settings) => {
    const resp = await api.put('/users/me/settings', { settings })
    return resp?.data?.settings || {}
  },
}

export default userService
